import { List, ListItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Link, Outlet } from 'react-router-dom'
import { useSystemManagementStyles } from './SystemManagement.styles'

export const SystemManagementPage = () => {
  const cn = useSystemManagementStyles()
  const { t } = useTranslation()

  return (
    <div className={cn.root}>
      <nav className={`${cn.templateSidebar} ${cn.sidebar}`}>
        <header>{t('system:system-management', 'system management')}</header>
        <List>
          <ListItem className={cn.listItem}>
            <Link to={`parties`}>{t('system:parties', 'parties')}</Link>
          </ListItem>
        </List>
      </nav>

      <main className={cn.templateMain}>
        <Outlet />
      </main>
    </div>
  )
}
